import * as jsxRuntime from "C:\\Eidos!!!\\travbyenV1\\72-eido-travbyen-version-1\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment